/* Bundle & Save builder (product page) */
(function () {
  const CHEVRON = '<svg class="bundle-builder__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
  function money(cents, format) {
    try { return theme.Currency.formatMoney(cents, format || theme.shopSettings.moneyFormat); } catch (e) { return (cents / 100).toFixed(2); }
  }
  function thumb(url) {
    return url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
  }

  const productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js').then((r) => r.json()).catch((e) => { delete productCache[handle]; throw e; });
    }
    return productCache[handle];
  }

  class BundleBuilder extends HTMLElement {
    constructor() {
      super();
      const read = (sel) => { try { return JSON.parse(this.querySelector(sel).textContent); } catch (e) { return null; } };
      this.products = read('[data-products]') || [];
      this.current = read('[data-current]');
      this.tiers = (read('[data-tiers]') || []).filter((t) => t.count > 0);
      if (this.current) productCache[this.current.handle] = Promise.resolve(this.current);
      if (this.current && !this.products.some((p) => p.id === this.current.id)) {
        this.products.unshift({ id: this.current.id, handle: this.current.handle, title: this.current.title, price: this.current.price, image: this.current.featured_image, available: this.current.available });
      }

      this.tiersEl = this.querySelector('[data-tiers-el]');
      this.rowsEl = this.querySelector('[data-rows]');
      this.totalEl = this.querySelector('[data-total]');
      this.compareEl = this.querySelector('[data-compare]');
      this.saveEl = this.querySelector('[data-save]');
      this.shipEl = this.querySelector('[data-ship]');
      this.shipBar = this.querySelector('[data-ship-progress]');
      this.shipText = this.querySelector('[data-ship-text]');
      this.errorEl = this.querySelector('[data-error]');
      this.successEl = this.querySelector('[data-success]');
      this.cta = this.querySelector('[data-add-bundle]');
      this.freeShipping = parseInt(this.dataset.freeShipping, 10) || 0;

      this.tierIndex = 0;
      this.rows = []; // { handle, product, variantId }
      this.siblings = {};

      this.tiersEl.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-tier]');
        if (btn) this.setTier(parseInt(btn.dataset.tier, 10));
      });
      this.rowsEl.addEventListener('change', (e) => this.onRowChange(e));
      this.cta.addEventListener('click', () => this.addBundle());

      this.setTier(0);
      window.SSLinkedOptions.siblingsForMany(this.products.map((p) => p.id))
        .then((data) => { this.siblings = data || {}; this.renderRows(); });
    }

    get tier() { return this.tiers[this.tierIndex] || { count: 3, free: 1 }; }

    setTier(i) {
      this.tierIndex = i;
      this.clearSuccess();
      const count = this.tier.count;
      while (this.rows.length < count) this.rows.push({ handle: this.current.handle, product: this.current, variantId: '' });
      this.rows.length = count;
      this.renderTiers();
      this.renderRows();
    }

    renderTiers() {
      this.tiersEl.innerHTML = this.tiers.map((t, i) =>
        '<button type="button" role="tab" class="bundle-builder__tier' + (i === this.tierIndex ? ' is-active' : '') + '" data-tier="' + i + '" aria-selected="' + (i === this.tierIndex) + '">' +
        (t.badge ? '<span class="bundle-builder__badge">' + esc(t.badge) + '</span>' : '') +
        '<span class="bundle-builder__tier-name">' + esc(t.name) + '</span>' +
        (t.sub ? '<span class="bundle-builder__tier-sub">' + esc(t.sub) + '</span>' : '') +
        '</button>').join('');
    }

    rowPrice(row) {
      const v = this.variantFor(row);
      return v ? v.price : (row.product ? row.product.price : 0);
    }

    // The free pairs are always the cheapest rows (ties go to the later row),
    // matching how Shopify's Buy X Get Y discount applies at checkout.
    freeRows() {
      const order = this.rows.map((row, i) => ({ i, price: this.rowPrice(row) }))
        .sort((a, b) => a.price - b.price || b.i - a.i);
      return new Set(order.slice(0, this.tier.free).map((o) => o.i));
    }

    isFreeRow(i) {
      return this.freeRows().has(i);
    }

    renderRows() {
      const rowLabel = this.dataset.rowLabel || 'Pair';
      this.rowsEl.innerHTML = this.rows.map((row, i) => {
        const p = row.product;
        const free = this.isFreeRow(i);
        const sibs = (p && this.siblings[String(p.id)]) || [];
        const self = p ? sibs.find((s) => String(s.id) === String(p.id)) : null;
        const colour = { name: (self && self.name) || '', hex: (self && self.hex) || '' };
        const namedSibs = sibs.filter((s) => s.name);
        const isCurrent = p && p.id === this.current.id;
        // style options: one entry per product, but collapse siblings of the selected product to that product's title
        const sibIds = new Set(sibs.map((s) => String(s.id)));
        const styleOptions = this.products.filter((x) => x.id === p.id || !sibIds.has(String(x.id)));
        const price = p ? (this.variantFor(row) ? this.variantFor(row).price : p.price) : 0;
        const sizeOptions = p ? this.sizeOptions(p) : [];
        return '<div class="bundle-builder__row' + (free ? ' bundle-builder__row--free' : '') + '" data-row="' + i + '">' +
          '<div class="bundle-builder__row-head"><span class="bundle-builder__row-label">' + esc(rowLabel + ' ' + (i + 1)) +
          (isCurrent ? ' <small>' + esc(this.dataset.thisStyleText || '') + '</small>' : '') + '</span>' +
          '<span class="bundle-builder__row-price">' + (free ? '<s>' + esc(money(price)) + '</s> <b>' + esc(this.dataset.freeText || 'FREE') + '</b>' : esc(money(price))) + '</span></div>' +
          '<div class="bundle-builder__row-body">' +
          '<div class="bundle-builder__thumb">' + (p && p.featured_image ? '<img src="' + esc(thumb(p.featured_image)) + '" alt="">' : '') + '</div>' +
          '<div class="bundle-builder__fields">' +
          '<label class="bundle-builder__pill bundle-builder__pill--style"><select data-field="style" aria-label="Style">' +
          styleOptions.map((x) => '<option value="' + esc(x.handle) + '"' + (x.id === p.id ? ' selected' : '') + '>' + esc(x.title) + ' · ' + esc(money(x.price)) + '</option>').join('') +
          '</select>' + CHEVRON + '</label>' +
          '<div class="bundle-builder__pill-row">' +
          // Only show the colour pill when there are real colour names to show.
          // Otherwise it falls back to product titles and just repeats the style dropdown.
          (namedSibs.length > 1 || colour.name ?
            '<label class="bundle-builder__pill bundle-builder__pill--colour"><span class="bundle-builder__swatch" style="--swatch:' + (colour.hex || 'transparent') + '"></span><select data-field="colour" aria-label="Colour"' + (sibs.length < 2 ? ' disabled' : '') + '>' +
            (sibs.length ? sibs.map((s) => '<option value="' + esc(s.handle) + '"' + (String(s.id) === String(p.id) ? ' selected' : '') + (s.available === false ? ' disabled' : '') + '>' + esc(s.name) + (s.available === false ? ' (sold out)' : '') + '</option>').join('')
              : '<option selected>' + esc(colour.name) + '</option>') +
            '</select>' + CHEVRON + '</label>' : '') +
          '<label class="bundle-builder__pill bundle-builder__pill--size' + (row.error ? ' is-error' : '') + '"><select data-field="size" aria-label="Size">' +
          '<option value=""' + (row.variantId ? '' : ' selected') + ' disabled>' + esc(this.dataset.chooseSize || 'Choose your size') + '</option>' +
          sizeOptions.map((v) => '<option value="' + v.id + '"' + (String(v.id) === String(row.variantId) ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' (sold out)') + '</option>').join('') +
          '</select>' + CHEVRON + '</label>' +
          '</div></div></div></div>';
      }).join('');
      this.renderTotals();
    }

    sizeOptions(p) {
      if (!p || !p.variants) return [];
      if (p.variants.length === 1 && p.variants[0].title === 'Default Title') return [{ id: p.variants[0].id, title: 'One size', available: p.variants[0].available }];
      return p.variants.map((v) => ({ id: v.id, title: v.title, available: v.available }));
    }

    variantFor(row) {
      if (!row.product || !row.variantId) return null;
      return row.product.variants.find((v) => String(v.id) === String(row.variantId)) || null;
    }

    async onRowChange(e) {
      const select = e.target;
      this.clearSuccess();
      const rowEl = select.closest('[data-row]');
      if (!rowEl) return;
      const i = parseInt(rowEl.dataset.row, 10);
      const row = this.rows[i];
      const field = select.dataset.field;
      if (field === 'size') {
        row.variantId = select.value;
        row.error = false;
        select.closest('.bundle-builder__pill').classList.remove('is-error');
        if (this.rows.every((r) => r.variantId)) this.errorEl.hidden = true;
        this.renderTotals();
        this.updateRowPrice();
        return;
      }
      // style or colour: swap the row's product
      const handle = select.value;
      rowEl.classList.add('is-loading');
      try {
        const product = await getProduct(handle);
        row.handle = handle;
        row.product = product;
        // keep the same size if the new product has it
        const prev = this.variantFor({ product: this.rows[i].product, variantId: row.variantId });
        row.variantId = '';
        if (prev) {
          const same = product.variants.find((v) => v.title === prev.title && v.available);
          if (same) row.variantId = same.id;
        }
        if (product.variants.length === 1) row.variantId = product.variants[0].id;
        row.error = false;
      } catch (err) {
        console.error('bundle builder: product load failed', err);
      } finally {
        rowEl.classList.remove('is-loading');
      }
      this.renderRows();
    }

    // Refresh every row's price label: a size change can move which row is the cheapest (free) one.
    updateRowPrice() {
      const free = this.freeRows();
      this.rows.forEach((row, i) => {
        const rowEl = this.rowsEl.querySelector('[data-row="' + i + '"]');
        if (!rowEl) return;
        const priceEl = rowEl.querySelector('.bundle-builder__row-price');
        const price = this.rowPrice(row);
        rowEl.classList.toggle('bundle-builder__row--free', free.has(i));
        if (priceEl) priceEl.innerHTML = free.has(i) ? '<s>' + esc(money(price)) + '</s> <b>' + esc(this.dataset.freeText || 'FREE') + '</b>' : esc(money(price));
      });
    }

    renderTotals() {
      const free = this.freeRows();
      let full = 0, pay = 0;
      this.rows.forEach((row, i) => {
        const price = this.rowPrice(row);
        full += price;
        if (!free.has(i)) pay += price;
      });
      this.totalEl.textContent = money(pay);
      this.compareEl.textContent = full > pay ? money(full) : '';
      this.saveEl.textContent = full > pay ? 'You save ' + money(full - pay) : '';
      if (this.freeShipping > 0) {
        this.shipEl.hidden = false;
        const pct = Math.min(100, Math.round(pay / this.freeShipping * 100));
        this.shipBar.style.width = pct + '%';
        this.shipText.textContent = pay >= this.freeShipping
          ? (this.dataset.freeShippingText || 'Free shipping unlocked 🎉')
          : 'Add ' + money(this.freeShipping - pay) + ' more for free shipping';
      }
    }

    // The success banner describes the bundle just added; hide it as soon as the selection changes
    clearSuccess() {
      if (this.successEl) this.successEl.hidden = true;
    }

    showSuccess() {
      if (!this.successEl) return;
      const free = this.freeRows();
      let full = 0, pay = 0;
      this.rows.forEach((row, i) => {
        const price = this.rowPrice(row);
        full += price;
        if (!free.has(i)) pay += price;
      });
      const text = (this.dataset.successText || '').replace('{free}', String(this.tier.free)).replace('{saved}', money(full - pay));
      this.successEl.textContent = text;
      this.successEl.hidden = !text;
    }

    async addBundle() {
      // validate sizes
      let firstBad = null;
      this.rows.forEach((row, i) => {
        if (!row.variantId) {
          row.error = true;
          const pill = this.rowsEl.querySelector('[data-row="' + i + '"] .bundle-builder__pill--size');
          if (pill) { pill.classList.add('is-error'); if (!firstBad) firstBad = pill; }
        }
      });
      if (firstBad) {
        this.errorEl.textContent = this.dataset.errorText || 'Please choose a size for every pair.';
        this.errorEl.hidden = false;
        firstBad.querySelector('select').focus();
        return;
      }
      this.errorEl.hidden = true;
      if (this.successEl) this.successEl.hidden = true;

      const qty = {};
      this.rows.forEach((row) => { qty[row.variantId] = (qty[row.variantId] || 0) + 1; });
      const items = Object.keys(qty).map((id) => ({ id: parseInt(id, 10), quantity: qty[id] }));

      this.cta.classList.add('loading');
      this.cta.disabled = true;
      try {
        const res = await fetch(this.dataset.cartUrl, { ...fetchConfig('javascript'), body: JSON.stringify({ items }) });
        const state = await res.json();
        if (state.status && state.status !== 200) {
          this.errorEl.textContent = state.description || state.message || 'Could not add to cart';
          this.errorEl.hidden = false;
          return;
        }
        const opened = window.ssOpenCart ? await window.ssOpenCart() : false;
        if (!opened) window.location.href = '/cart';
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state } }));
        this.showSuccess();
      } catch (e) {
        console.error('bundle builder: add failed', e);
        this.errorEl.textContent = 'Could not add to cart';
        this.errorEl.hidden = false;
      } finally {
        this.cta.classList.remove('loading');
        this.cta.disabled = false;
      }
    }
  }

  customElements.define('bundle-builder', BundleBuilder);
})();
